(function () {
  'use strict';

  var id = 'wordcloud',
    wordcloudMeasures = null;
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'AggregationUtils', function (CardQueryResource, AggUtils) {
    return {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        return CardQueryResource.getWithProgress("/wordcloud/data", cfg.cardId, cfg.params, cfg.cardToPreview, 'wordcloud-graph-' + cfg.cardId);
      },
      getWordcloud: function getwordcloudGraph(data, config) {
        var chart = {
          chart: {
            type: 'wordcloud'
          },
          series: [{
            type: 'wordcloud',
            name: config.measures[0].name,
            data: _.map(data, function (d) {
              return {
                name: AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]),
                weight: d.aggregations[0].value
              };
            })
          }],
          tooltip: {
            style: {
              padding: '1px'
            },
            // WSLRS-5076 Default is 8px, caused strange bleed with legend so made margin 8px below instead
            headerFormat: '<div class="watershed-tooltip"><table><thead><tr><th>{point.name}</th></tr></thead>',
            pointFormat: '<tr style="color:{series.color}"><td>{series.name}:</td>' + '<td>{point.weight}</td></tr>',
            footerFormat: '</table></div>',
            shared: true
          },
          title: {
            text: ''
          }
        };
        return chart;
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/wordcloud/:cardId', {
      templateUrl: 'modules/app/wordcloud/wordcloud-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/wordcloud/:cardId/top', {
      templateUrl: 'modules/app/wordcloud/wordcloud-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "wordcloud": "activity"
    });
  }]).controller(id + ".CardConfiguration", ['$controller', '$rootScope', '$scope', 'Measures', function ($controller, $rootScope, $scope, Measures) {
    $scope.tempMeasures = wordcloudMeasures;
    $scope.templateType = id;
    $scope.getMeasures = Measures.getCommonMeasures;
    $scope.newtworkHelpText = {
      helpTitle: 'Wordcloud',
      detailText: "In the Network section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. "
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    //clear out any listerMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      wordcloudMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams) {
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    if (!$scope.config.measures || $scope.config.measures.length < 1) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please select at least 1 measure";
      return;
    }
    $scope.defaultSummary = 'wordcloud Graph of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      params: {
        "_limit": 10,
        "_offset": 0
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      $scope.wordcloudGraph = Utils.getWordcloud(r.results[0].result.data, $scope.config);
      $scope.hasData = r.results[0].result.data.length > 0 && $scope.measures.length > 0;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + '.Utils', function ($scope, $routeParams, CardRegistry, CardUtils, Utils) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.measures = $scope.config.measures;
    if (!$scope.config.measures || $scope.config.measures.length < 1) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please select at least 1 measure";
      return;
    }
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
      params: {}
    };
    $scope.nodeName = null;
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      $scope.wordcloudGraph = Utils.getWordcloud(r.results[0].result.data, $scope.config);
      $scope.hasData = r.results[0].result.data.length > 0 && $scope.measures.length > 0;
    }, function () {
      $scope.hasData = false;
    });
  }]);
})();
